/**
 * Add a new client
 *
 * @param client
 * @returns {function(*)}
 */
import {addNotification as notify} from 'reapop';
import * as contactActions from "../graphql/actions/clientContact";
import l10n from "../l10n/localization";
import * as types from "../constants/actionTypes";
import * as creationActions from "./creation";
import * as ajaxRoutes from "../constants/ajaxRoutes";
import * as authHandler from "../utils/authHandler";


export function add(contact, clientID) {
    return dispatch => {
        dispatch(loading());
        dispatch(saving(contact));
        contactActions.add(
            function (response) {
                dispatch(saved(response.data.createClientContact));
                dispatch(notify({message: l10n.messages.success, status: 'success'}));
                dispatch(creationActions.receivednewlyCreatedClientContact(response.data.createClientContact));
                dispatch(fetchContacts(clientID, true));
            },
            function (error) {
                dispatch(notify({message: error.message, status: 'error'}));
                dispatch(errorSaving());
            },
            contact
        );
    };
}


export function edit(contact, clientID) {
    let id = contact.id;
    delete contact.id;
    delete contact.__typename;

    return dispatch => {
        dispatch(loading());
        dispatch(saving(contact));
        contactActions.edit(
            function (response) {
                dispatch(saved(response.data.editClientContact));
                dispatch(notify({message: l10n.messages.success, status: 'success'}));
                dispatch(fetchContacts(clientID, true));
            },
            function (error) {
                dispatch(notify({message: error.message, status: 'error'}));
                dispatch(errorSaving());
            },
            id,
            contact
        );
    };
}

export function fetchContacts(clientId, force = false) {
    return dispatch => {
        dispatch(loading());
        contactActions.getContacts(
            function (response) {
                dispatch(receiveContacts(response.data.clientContacts));
            },
            function (error) {
                dispatch(notify({message: error.message, status: 'error'}));
            },
            clientId,
            force
        );
    };
}

export function deleteClientcontact(contactID) {
    return dispatch => {
        let url = ajaxRoutes.API_ROUTE + "/clientcontact/delete/"+contactID;
        let headers = new Headers({"X-Authorization": 'Bearer ' + authHandler.getToken()});
        dispatch(deletingClientcontact());
        fetch(url, {headers: headers})
            .then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                dispatch(notify({message: l10n.messages.removed, status: 'success'}));
                return response;
            })
            .then((response) => {
                dispatch(doneDeletingClientcontact());
                response.json().then(function(data) {
                    dispatch(fetchContacts(data.client,true));
                });
            })
            .catch((error) => {
                dispatch(notify({message: error.message, status: 'error'}));
                dispatch(doneDeletingClientcontact());
            });
    };
}

export function deletingClientcontact () {
    return {
        type: types.DELETING_CLIENT_CONTACT
    };
}

export function doneDeletingClientcontact (){
    return {
        type: types.DONE_DELETING_CLIENT_CONTACT
    };
}


export function loading() {
    return {
        type: types.LOADING_CLIENT_CONTACT
    };
}

export function saving(contact) {
    return {
        type: types.SAVING_CLIENT_CONTACT,
        payload: contact
    };
}

export function errorSaving() {
    return {
        type: types.ERROR_SAVING_CLIENT_CONTACTS,
    };
}

export function saved(contact) {
    return {
        type: types.SAVED_CLIENT_CONTACT,
        payload: contact
    };
}

export function receiveContacts(data) {
    return {
        type: types.RECEIVED_CLIENT_CONTACTS,
        payload: data
    };
}

export function errorMessage(message) {
    return dispatch => {
        dispatch(notify({message: message, status: 'error',dismissAfter: 8000}));
    };
}


// WEBPACK FOOTER //
// ./src/actions/clientContact.js